import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PageHeader, PageSection } from '@/components/layouts/page-layout';

export function DashboardIndex() {
  return (
    <>
      <PageHeader
        title="Dashboard"
        description="Overview and quick access to your workspace"
      />
      <PageSection>
      <Card>
        <CardHeader>
          <CardTitle>Dashboard Home</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Select a menu item to get started.
          </p>
        </CardContent>
      </Card>
      </PageSection>
    </>
  );
}
